import React from 'react';
import PropTypes from 'prop-types';
import { DEFAULT_EMPTY_VALUE } from '../../../../constants/strings';

import styles from './index.styl';

const InfoSection = ({ entries }) => {
  return (
    <div className={styles.entries}>
      {entries.map(({ value, label }) => (
        <div key={label}>
          <div className={styles.entryTitle}>{label}</div>
          <div className={styles.entryValue}>
            {value || DEFAULT_EMPTY_VALUE}
          </div>
        </div>
      ))}
    </div>
  );
};

InfoSection.propTypes = {
  entries: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default InfoSection;



// WEBPACK FOOTER //
// ./src/components/Paperwork/components/InfoSection/index.jsx